<div class="bottom-toggle-z-index"></div>
<div class="bottom-toggle"></div>
<span class="tooltip-span">
    {{tooltip | translate}}
</span>
